import { useGetAccountTransactionsQuery } from "@/modules/account/services";
import { AppPaths } from "@/shared/common/enums";
import { HistoryDetail, SeeMore } from "@/shared/components";
import { buildRoute, getFormattedHistoryList } from "@/shared/helpers";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  accountId: string;
}

export const AccountDetailHistory = ({ accountId }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: accountHistory, isFetching } = useGetAccountTransactionsQuery(
    { accountId },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handleSeeMore = () => {
    const url = buildRoute(
      AppPaths.AccountHistory,
      { accountId }
    );
    navigate(url);
  };

  const historyList = useMemo(() => {
    return getFormattedHistoryList({
      list: accountHistory ?? [],
      beneficiaryKey: "sender",
    });
  }, [accountHistory]);

  return (
    <div className="mt-40">
      <div className="flexbox align-items--center">
        <Heading className="content-title" size="xsmall" weight="bolder">
          {t("accounts.accountHistory")}
        </Heading>
        <SeeMore action={handleSeeMore} className="ml-8 mt-4"/>
      </div>
      <HistoryDetail
        isFetching={isFetching}
        historyList={historyList}
      />
    </div>
  );
};
